import PostCard from './posts'
import FeaturedContentTop from './featured-content-top'

export default function () {
  if (document.querySelector('.PageMain .PageMain--great-pet-picks')) {
    if (
      document.querySelectorAll(
        '.PageMain--great-pet-picks .MoreFeaturedCategories'
      ).length > 0
    ) {
      PostCard()
    }

    if (
      document.querySelectorAll(
        '.PageMain--great-pet-picks .FeaturedContentTop .tns-gallery'
      ).length > 0
    ) {
      import(
        /* webpackChunkName: "tiny-slider-module" */ 'tiny-slider/src/tiny-slider'
      ).then((module) => {
        const { tns } = module

        FeaturedContentTop(tns)
      })
    }
  }
}
